export * from "ce/reducers/entityReducers/canvasWidgetsReducer";
import { default as CE_canvasWidgetsReducer } from "ce/reducers/entityReducers/canvasWidgetsReducer";
export default CE_canvasWidgetsReducer;
